import { env } from '../environment';

const getTagManagerBodyScript = (googleTagManagerKey: string) => {
  const tagManagerBodyScriptTag = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${googleTagManagerKey}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';

  tagManagerBodyScriptTag.appendChild(iframe);

  return tagManagerBodyScriptTag;
};

const getTagManagerHeadScript = (googleTagManagerKey: string) => {
  const tagManagerHeadScriptString = `(function(w,d,s,l,i){\nw[l]=w[l]||[];\nw[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});\nvar f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\nj.async=true;\nj.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;\nf.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','${googleTagManagerKey}');`;
  const tagManagerHeadScriptFormatCleared = tagManagerHeadScriptString.replace(/(\r\n|\n|\r)/gm, '');
  const tagManagerHeadScriptTag = document.createElement('script');
  tagManagerHeadScriptTag.innerHTML = tagManagerHeadScriptFormatCleared;

  return tagManagerHeadScriptTag;
};

export const initTagManager = (): void => {
  const googleTagManagerKey = env.GOOGLE_TAG_MANAGER_CONTAINER_ID || '';
  const tagManagerHeadScriptTag = getTagManagerHeadScript(googleTagManagerKey);
  const tagManagerBodyScriptTag = getTagManagerBodyScript(googleTagManagerKey);
  const headElement = document.getElementsByTagName('head')[0];
  const bodyElement = document.getElementsByTagName('body')[0];
  if (headElement) {
    headElement.append(tagManagerHeadScriptTag);
  }
  if (bodyElement) {
    bodyElement.append(tagManagerBodyScriptTag);
  }
};
